import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/image/idlefish-good.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-114ee1fa")

_pushScopeId("data-v-114ee1fa")
const _hoisted_1 = { class: "ui__reportCarInfo_main" }
const _hoisted_2 = { class: "ui__reportCarInfo_body" }
const _hoisted_3 = { class: "ui__reportCarInfo_title" }
const _hoisted_4 = { class: "ui__reportCarInfo_content" }
const _hoisted_5 = { class: "ui__reportCarInfo_vin" }
const _hoisted_6 = { class: "ui__reportCarInfo_mileage" }
const _hoisted_7 = { class: "ui__reportCarInfo_year" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "bottom-box" }, [
  /*#__PURE__*/_createVNode("div", { class: "bottom-line" }),
  /*#__PURE__*/_createVNode("div", { class: "ui__reportCarInfo_logo" }, [
    /*#__PURE__*/_createVNode("img", { src: _imports_0 })
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.state.carModel), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, "VIN：" + _toDisplayString(_ctx.state.vin), 1),
        _createVNode("div", _hoisted_6, "｜" + _toDisplayString(_ctx.state.mileage), 1),
        _createVNode("div", _hoisted_7, "｜" + _toDisplayString(_ctx.state.year), 1)
      ]),
      _hoisted_8
    ])
  ]))
})